import { Query } from '../../../../../hooks/queries'
import { useContrastQuery } from '../../../../../hooks/use-contrast-query'
import { ThisConnector } from '../../../../../api/connector'

interface MetadataFieldsArgs {
  organizationUuid: string
}

interface MetadataFieldsResponse {
  success: boolean
  messages: string[]
  fields: any[]
}

export async function getMetadataFields(
  this: ThisConnector,
  { organizationUuid }: { organizationUuid: string }
) {
  return this.connector.get(`${organizationUuid}/metadata/fields`)
}

export const useMetadataFields = ({ organizationUuid }) => {
  const { isLoading, error, data } = useContrastQuery<
    MetadataFieldsArgs,
    MetadataFieldsResponse
  >([Query.METADATA_FIELDS, organizationUuid], getMetadataFields, {
    organizationUuid
  })

  return {
    isLoading,
    error,
    data
  }
}
